export const SET_POV = 'identifiers/SET_POV'
export const SET_SEX = 'identifiers/SET_SEX'
export const SET_AGE = 'identifiers/SET_AGE'
export const SET_AGE_INPUT_ATTEMPTED = 'identifiers/SET_AGE_INPUT_ATTEMPTED'
export const SET_NAME = 'identifiers/SET_NAME'
export const SET_PROFILE_ID = 'identifiers/SET_PROFILE_ID'
export const SET_AGE_ERROR = 'identifiers/SET_AGE_ERROR'
export const SET_INFANT_EXPLANATION = 'identifiers/SET_INFANT_EXPLANATION'



// WEBPACK FOOTER //
// ./assets/identifiers/actionTypes.js